/* eslint-disable @typescript-eslint/camelcase */

export const DEFAULT_TEMPLATE = {
  fonts: [],
  pages: [
    {
      components: [],
    },
  ],
};

export const DEFAULT_VALUES = {
  signages_signages_inputs_store: '380',
  signages_signages_inputs_autoMode: true,
  signages_signages_inputs_reference: '1484',
  signages_signages_inputs_date: '2018-11-16',
  signages_signages_attributes_inGaia: false,
  signages_signages_attributes_gaiaLinks: '',
  designation: 'Disjoncteur de branchement bipolaire 500 mA, 60/75/90 A, ITRON',
  description: 'Description',
  eanRef: '3351840420471 - 1484',
  rayon: 3,
  useMarque: true,
  marque: 'https://piivolm.blob.core.windows.net/assets/images/logos/itron.jpg',
  pefc: false,
  capaciteDeVente: 1,
  price: 159,
  uniteDeVente: 'Unite de vente',
  ecopart: 'Ecopart',
};

export const DEFAULT_TYPES = {
  signages_signages_inputs_autoMode: 'Boolean',
  signages_signages_inputs_reference: 'String',
  signages_signages_inputs_store: 'Links',
  signages_signages_inputs_date: 'Date',
  signages_signages_attributes_inGaia: 'Boolean',
  signages_signages_attributes_gaiaLinks: 'String',
  designation: 'String',
  description: 'String',
  eanRef: 'String',
  rayon: 'Numeric',
  useMarque: 'Boolean',
  marque: 'String',
  pefc: 'Boolean',
  capaciteDeVente: 'Numeric',
  price: 'Numeric',
  uniteDeVente: 'String',
  ecopart: 'String',
};
